import React from "react";

import { useTranslation } from "react-i18next";

import { FormChoiceInput } from "@/uiKit/molecules/form/FormChoiceInput.tsx";

type DiabetesType = "type1" | "type2" | "gestational";

export type DiabetesTypeFormFieldProps = {
  name?: string;
  allowedDiabetesTypes: DiabetesType[];
  translationMapping: (type: DiabetesType) => string;
  className?: string;
};

export const DiabetesTypeFormField: React.FC<DiabetesTypeFormFieldProps> = ({
  name = "diabetesType",
  allowedDiabetesTypes,
  translationMapping,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <FormChoiceInput
      id="diabetes-type-form-field"
      name={name}
      label={t("diabetesForms.diabetesType")}
      className={className}
      choices={allowedDiabetesTypes.map(type => ({
        label: t(translationMapping(type)),
        value: type,
      }))}
      reserveErrorSpace
    />
  );
};
